<template>
    <v-container>
        <v-row>
            <v-col 
                :cols="(data.cols) ? data.cols.mobile : 10"
                :md="(data.cols) ? data.cols.tablet  : 8"
                :lg="(data.cols) ? data.cols.desktop  : 6"
                class="mx-auto" 
                data-aos="fade-right" 
                >
                <v-hover>
                    <template v-slot:default="{ isHovering, props }">
                        <v-btn
                            v-if="data.button.target!='_blank'" 
                            :to="(data.button.route)  ? data.button.route : data.button.link" 
                            :target="data.button.target"
                            :block="data.button.block" 
                            :size="data.button.size"
                            v-bind="props"
                            :elevation="data.button.elevation" 
                            :variant="data.button.variant" 
                            :class="isHovering ? 'isHovering '+data.button.class : '  '+ data.button.class" 
                            :color="data.button.color"
                            :prepend-icon="data.button.prependIcon"
                            :append-icon="data.button.appendIcon"
                            >
                            <span :class="data.button.class"> {{data.button.text}} </span>
                           
                        </v-btn>
                        <v-btn
                            v-if="data.button.target=='_blank'" 
                            :href="data.button.link" 
                            :target="data.button.target"
                            :block="data.button.block" 
                            :size="data.button.size"
                            v-bind="props"
                            :elevation="data.button.elevation" 
                            :variant="data.button.variant" 
                            :class="isHovering ? 'isHovering '+data.button.class : '  '+ data.button.class" 
                            :color="data.button.color"
                            :prepend-icon="data.button.prependIcon"
                            :append-icon="data.button.appendIcon"
                            >
                            <span :class="data.button.class"> {{data.button.text}} </span>
                           
                        </v-btn>

                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
}
</script>